import { useEffect, useState } from "react";

export interface Viewport {
  width: number;
  height: number;
  orientation: "portrait" | "landscape";
}

function getViewport(): Viewport {
  if (typeof window === "undefined") {
    return { width: 1024, height: 768, orientation: "landscape" };
  }
  const w = window.innerWidth;
  const h = window.innerHeight;
  return {
    width: w,
    height: h,
    orientation: h >= w ? "portrait" : "landscape",
  };
}

export function useViewport(): Viewport {
  const [vp, setVp] = useState<Viewport>(getViewport);
  useEffect(() => {
    const update = () => setVp(getViewport());
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);
  return vp;
}
